module.exports = __webpack_public_path__ + "static/transporter-active-a5208cea92f96c659b9826df373ed680.png";